module.exports = __webpack_public_path__ + "static/s3-1-truck-d-3cf964dee496673d3d06d33f71b90c15.jpg";